export class PriceList {
	id: number;
	price: number;
	listData: ListData;
}

export class ListData {
	id: number;
	name: string;
}


export class PriceListView {
	priceList: PriceList;
	product: string;
	product_id: number;
	cost!: number;
	loading!: boolean;
	constructor(priceList:PriceList, product:string, product_id:number){
		this.priceList = priceList;
		this.product = product;
		this.product_id = product_id;
	}
}

export class ProductPriceListResponse {
	id: number;
	name: string;
}

export interface ProductPriceResponse {
  id: number;
  metaProductId: number | null;
  code: string;
  barCode: string | null;
  name: string;
  description: string | null;
  image: string | null;
  bought: boolean;
  sold: boolean;
  company: number;
  measurement: number;
  category: number;
  compound: boolean;
  active: boolean;
  type: string;
  productType: string;
  expenseType: string | null;
  measurementName: string;
  price: number;
}


export class producPriceRequest {
	listId: number;
	price: number;
	productId: number;
}